<template>
  <div
    :class="
      'form-group ' +
        (input.type === 'file'
          ? 'upload-file-group'
          : input.type === 'image' || input.type === 'video'
          ? 'upload-image-group'
          : '') +
        (input.class ? ' ' + input.class : '')
    "
    :style="input.type === 'hidden' ? 'display: none;' : ''"
  >
    <!-- {{#if input.label}} -->
    <div class="mb-2" v-if="input.preHtml" v-html="input.preHtml"></div>
    <h5 class="mb-3 text-primary" v-if="input.header">{{ input.header }}</h5>
    <div v-if="input.label">
      <!-- {{#if input.labelCheckbox}} -->
      <div
        v-if="input.labelCheckbox"
        class="checkbox custom-control custom-checkbox"
      >
        <input.type=="checkbox" class="custom-control-input"
        :id="input.labelCheckbox">
        <label class="custom-control-label" :for="input.labelCheckbox">
          {{ input.label }}
          <!-- {{#if !input.optional}} -->
          <span v-if="!input.optional" class="text-danger">*</span>
          <!-- {{/if}} -->
        </label>
      </div>
      <!-- {{:else if input.labelRadio}} -->
      <div
        v-else-if="input.labelRadio"
        class="radio custom-control custom-radio"
      >
        <input.type=="radio" class="custom-control-input"
        :name="input.labelRadio" :value="input.valueRadio"
        :id="input.labelRadio+id">
        <label class="custom-control-label" :for="input.labelRadio + id">
          {{ input.label }}
          <!-- {{#if !input.optional}} -->
          <span v-if="!input.optional" class="text-danger">*</span>
          <!-- {{/if}} -->
        </label>
      </div>
      <!-- {{:else}} -->
      <label v-else :class="'d-flex ' + (input.action ? 'flex-between' : '')">
        {{ input.label }}
        <!-- {{#if !input.optional}} -->
        <i v-if="input.optional" class="ml-2 text-muted">&nbsp;&nbsp;ops</i>
        <!-- {{/if}} -->
        <div v-if="input.action" class="d-flex d-flex-align-center">
          <!-- <a :href="input.action" target="_blank">{{input.actionText?input.actionText:input.action}}</a> -->
          <button
            v-if="input.refresh"
            @click="input.refresh"
            class="btn btn-outline-primary btn-sm btn-icon mr-2"
          >
            <i class="material-symbols-outlined">refresh</i>
          </button>
          <a
            :href="input.action"
            target="_blank"
            :class="
              `btn btn-outline-secondary btn-sm ${
                input.actionIcon ? 'btn-with-icon-left' : ''
              }`
            "
          >
            <i class="material-symbols-outlined" v-if="input.actionIcon">{{
              input.actionIcon
            }}</i>
            {{ input.actionText ? input.actionText : input.action }}</a
          >
        </div>
      </label>
      <!-- {{/if}} -->
    </div>
    <!-- {{/if}} -->

    <!-- {{#if input.type==="date"}} -->
    <Datepicker
      v-if="input.type == 'date'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{#if input.type==="manualdate"}} -->
    <ManualDatepicker
      v-else-if="input.type == 'manualDate'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="checkbox"}} -->
    <InputCheckbox
      v-else-if="input.type == 'checkbox'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="checkbox_old"}} -->
    <InputCheckboxOld
      v-else-if="input.type == 'checkbox_old'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="email"}} -->
    <InputEmail
      v-else-if="input.type == 'email'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="hidden"}} -->
    <InputHidden
      v-else-if="input.type == 'hidden'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="money"}} -->
    <InputMoney
      v-else-if="input.type == 'money'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="number"}} -->
    <InputNumber
      v-else-if="input.type == 'number'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <InputAddonRight
      v-else-if="input.type == 'addon-right'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <InputAddonLeft
      v-else-if="input.type == 'addon-left'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="password"}} -->
    <InputPassword
      v-else-if="input.type == 'password'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="percentage"}} -->
    <InputPercentage
      v-else-if="input.type == 'percentage'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="radio"}} -->
    <InputRadio
      v-else-if="input.type == 'radio'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <InputRadioOld
      v-else-if="input.type == 'radio_old'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="select"}} -->
    <Select
      v-else-if="input.type == 'select'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="textarea"}} -->
    <Textarea
      v-else-if="input.type == 'textarea'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="file"}} -->
    <UploadFile
      v-else-if="input.type == 'file'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />

    <UploadMultiFile
      v-else-if="input.type == 'multifile'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="image"}} -->
    <UploadImage
      v-else-if="input.type == 'image'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="video"}} -->
    <!-- <UploadVideo v-else-if="input.type=='video'" :input="input" :value="value"
      @handleChange="e => handleChange(e)" /> -->
    <!-- {{:else if input.type==="wysiwyg"}} -->
    <Wysiwyg
      v-else-if="input.type == 'wysiwyg'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{:else if input.type==="tag"}} -->
    <Tags v-else-if="input.type == 'tag'" />
    <!-- {{:else if input.type==="text"}} -->
    <InputText
      v-else-if="input.type == 'text'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <InputTime
      v-else-if="input.type == 'time'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <button
      v-else-if="input.type == 'button'"
      class="btn btn-primary btn-block btn-with-icon-right"
      @click="() => input.function()"
    >
      {{ input.content }}
      <i class="material-symbols-outlined">chevron_right</i>
    </button>
    <span
      v-else-if="input.type == 'no-input'"
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    ></span>
    <!-- {{:else}} -->
    <InputText
      v-else
      :input="input"
      :value="value"
      @handleChange="(e) => handleChange(e)"
    />
    <!-- {{/if}} -->

    <!-- {{#if input.additional}} -->
    <small v-if="input.additional" class="form-text text-muted">{{
      input.additional
    }}</small>
    <!-- <pre>{{ JSON.stringify(input, null, 2) }}</pre>
    {{ input.error }} -->
    <p v-if="input.error" class="form-text text-danger mb-0">
      {{ input.error }}
    </p>
    <!-- {{/if}} -->
    <div class="mt-2" v-if="input.postHtml" v-html="input.postHtml"></div>
  </div>
</template>
<script>
import Wysiwyg from "./Wysiwyg.vue";
import UploadImage from "./UploadImage.vue";
// import UploadVideo from './UploadVideo.vue';
import UploadFile from "./UploadFile.vue";
import UploadMultiFile from "./UploadMultiFile.vue";
import Textarea from "./Textarea.vue";
import Select from "./Select.vue";
import InputText from "./InputText.vue";
import InputTime from "./InputTime.vue";
import InputRadio from "./InputRadio.vue";
import InputRadioOld from "./InputRadioOld.vue";
import InputPercentage from "./InputPercentage.vue";
import InputAddonRight from "./InputAddonRight.vue";
import InputAddonLeft from "./InputAddonLeft.vue";
import InputPassword from "./InputPassword.vue";
import InputNumber from "./InputNumber.vue";
import InputMoney from "./InputMoney.vue";
import InputHidden from "./InputHidden.vue";
import InputEmail from "./InputEmail.vue";
import InputCheckbox from "./InputCheckbox.vue";
import InputCheckboxOld from "./InputCheckboxOld.vue";
import Datepicker from "./Datepicker.vue";
import ManualDatepicker from "./ManualDatepicker.vue";
export let input;
let id = Math.random(1024);

export default {
  name: "FormGroup",
  components: {
    Wysiwyg,
    UploadImage,
    UploadFile,
    UploadMultiFile,
    Textarea,
    Select,
    InputText,
    InputTime,
    InputRadio,
    InputRadioOld,
    InputPercentage,
    InputPassword,
    InputNumber,
    InputMoney,
    InputHidden,
    InputEmail,
    InputCheckbox,
    InputCheckboxOld,
    Datepicker,
    ManualDatepicker,
    InputAddonRight,
    InputAddonLeft,
  },
  props: {
    input: Object,
    value: [Number, String, Array, Date],
  },
  data: function() {
    return {
      id: id,
    };
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
<style>
.custom-control .custom-control-label {
  line-height: 1;
}
.custom-control-label::before,
.custom-control-label::after {
  top: -0.125rem;
}
</style>
